<template>
  <HModal
    ref="modal"
    auto-opening
  >
    <VCard
      color="white"
      no-padding
    >
      <div class="row">
        <div class="col-12 col-md-6 p-0">
          <NuxtImg
            format="webp"
            loading="lazy"
            quality="80"
            fit="outside"
            src="/img/miniature_livre-blanc.png"
            class="whitebook__img"
          />
        </div>
        <div class="col-12 col-md-6 p-5">
          <HH3
            class="mb-4"
          >
            Téléchargez gratuitement votre guide vendeur !
          </HH3>
          <p class="mb-4">
            Vendre avec succès commence ici.
            Des conseils pratiques et actionnables directement pour préparer, organiser et finaliser votre vente immobilière.
          </p>
          <LazyHContactForm
            :use="contactFormOptions"
            acquisition-source="livre_blanc_haussmann"
            @submit:end="download"
          >
            <template #submitButtonLabel>
              Télécharger gratuitement
            </template>
          </LazyHContactForm>
        </div>
      </div>
    </VCard>
  </HModal>
</template>

<script lang="ts" setup>
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const viewport = useViewport()

const modal = ref(true)

const contactFormOptions = {
  email: {
    activated: true,
    verification: false
  },
  phone: {
    activated: false,
    verification: false
  },
  names: {
    activated: false
  },
  cgu: {
    activated: false
  },
  optin: {
    activated: true,
    required: true
  },
  is_selling: {
    activated: false
  },
  company: {
    activated: false,
    toggle: false
  },
  second_contact: {
    activated: false,
    toggle: false,
    label: 'annonces.secondBuyer'
  },
  partner_optin: {
    activated: false,
    label: 'annonces.partner_optin'
  },
  agent_profession: {
    activated: false
  },
  disabledField: true
}

function download () {
  // window.open(new URL('/pdf/livre_blanc_homeloop.pdf', import.meta.url).href, '_blank')?.focus()
  const link = document.createElement('a')
  link.download = 'livre_blanc_homeloop'
  link.href = '/pdf/livre_blanc_homeloop.pdf'
  link.dispatchEvent(new MouseEvent('click'))

  modal.value.close()
}
</script>

<style lang="scss" scoped>
.whitebook__img {
  aspect-ratio: 4 / 3;
  object-fit: cover;
  height: 100%;
  width: 100%;

  @include media-breakpoint-down(md) {
    height: auto;
  }
}
</style>
